var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 16C16.9 16 15.9583 15.6083 15.175 14.825C14.3917 14.0417 14 13.1 14 12C14 10.9 14.3917 9.95833 15.175 9.175C15.9583 8.39167 16.9 8 18 8C19.1 8 20.0417 8.39167 20.825 9.175C21.6083 9.95833 22 10.9 22 12C22 13.1 21.6083 14.0417 20.825 14.825C20.0417 15.6083 19.1 16 18 16ZM10 24V21.2C10 20.6333 10.1458 20.1125 10.4375 19.6375C10.7292 19.1625 11.1167 18.8 11.6 18.55C12.6333 18.0333 13.6833 17.6458 14.75 17.3875C15.8167 17.1292 16.9 17 18 17C19.1 17 20.1833 17.1292 21.25 17.3875C22.3167 17.6458 23.3667 18.0333 24.4 18.55C24.8833 18.8 25.2708 19.1625 25.5625 19.6375C25.8542 20.1125 26 20.6333 26 21.2V24H10Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.aefa643eab0c81127a68c18d1922781a.svg";
export { ForwardRef as ReactComponent };